(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('mobile-menu-toggle');
  var drawer = document.getElementById('mobile-menu-drawer');
  if(toggle && drawer){
    toggle.addEventListener('click', function () {
      var isOpen = drawer.classList.toggle('open');
      drawer.hidden = !isOpen;
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
